"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M87.9,362.7c32.6,18.6,65.3,28,102.6,28c121.2,0,188.8-102.5,188.8-188.7c0-2.3,0-7,0-9.3c11.7-7,25.6-18.6,37.3-32.6 c-11.7,2.3-25.6,9.3-37.3,9.3c11.7-7,21-18.6,28-34.9c-14,7-25.6,14-42,16.3c-14-14-30.3-23.3-49-23.3c-39.6,0-67.6,32.6-67.6,67.6 c0,7,2.3,9.3,2.3,16.3c-58.3-2.3-104.9-32.6-137.6-69.9c-7,9.3-9.3,21-9.3,32.6c0,23.3,11.7,44.3,30.3,55.9c-9.3,0-21-4.7-32.6-7 c0,30.3,23.3,55.9,53.6,65.2c-4.7,2.3-9.3,2.3-16.3,2.3c-2.3,0-9.3,0-11.7,0c7,25.6,32.6,44.3,60.6,44.3c-23.3,18.6-51.3,28-83.9,28 C97.3,362.7,94.9,362.7,87.9,362.7z"
  });
};

exports.default = _default;